const MARKDOWN_HELP = `
# JSON Query

JSON Query 기능을 사용하면 **JSON 데이터를 필터링, 변환 및 조회**할 수 있습니다.  
이 기능은 **JSON 구조화된 데이터에서 특정 정보를 추출**하는 데 유용합니다.

## 🛠 사용 방법

1. **입력값**: JSON 형식의 데이터
2. **쿼리**: 특정 필드 선택, 데이터 필터링, 배열 변환 등을 수행할 수 있는 쿼리 문자열
3. **결과 반환**: 쿼리 결과를 반환

## 📌 예제 1: JSON 객체에서 특정 필드 추출
### 입력 데이터:
\`\`\`json
{
  "name": "Alice",
  "age": 25,
  "email": "alice@example.com"
}
\`\`\`

### 쿼리:
\`\`\`json
"name"
\`\`\`

### 결과:
\`\`\`json
"Alice"
\`\`\`

---

## 📌 예제 2: 배열 필터링
### 입력 데이터:
\`\`\`json
{
  "users": [
    { "name": "Alice", "age": 25 },
    { "name": "Bob", "age": 30 },
    { "name": "Charlie", "age": 28 }
  ]
}
\`\`\`

### 쿼리:
\`\`\`json
"users[?(@.age > 25)]"
\`\`\`

### 결과:
\`\`\`json
[
  { "name": "Bob", "age": 30 },
  { "name": "Charlie", "age": 28 }
]
\`\`\`

---

## 📌 예제 3: 특정 키 값을 가진 데이터 추출
### 입력 데이터:
\`\`\`json
{
  "orders": [
    { "id": 1, "status": "pending" },
    { "id": 2, "status": "shipped" },
    { "id": 3, "status": "delivered" }
  ]
}
\`\`\`

### 쿼리:
\`\`\`json
"orders[?(@.status == 'shipped')]"
\`\`\`

### 결과:
\`\`\`json
[
  { "id": 2, "status": "shipped" }
]
\`\`\`

---

## 📌 지원하는 연산자
- 필드 접근: \`field\`
- 배열 필터링: \`array[?(@.field <operator> value)]\`
- 연산자:
  - \`==\` (같음)
  - \`!=\` (다름)
  - \`>\`, \`>=\` (크거나 같음)
  - \`<\`, \`<=\` (작거나 같음)

## ⚠ 주의 사항
- 입력 데이터는 반드시 **유효한 JSON 형식**이어야 합니다.
- 쿼리 문법이 올바르지 않으면 **에러가 발생할 수 있습니다.**
- 대소문자를 구별할 수 있습니다.

💡 **JSON 데이터를 손쉽게 쿼리하여 원하는 정보를 빠르게 추출하세요!**
`

export const JsonQuery = {
  name: 'json-query',
  label: 'JSON Query',
  specifications: [
    {
      type: 'text',
      name: 'query',
      label: 'JSON Query Expression'
    }
  ],
  help: MARKDOWN_HELP
}
